"use strict";
const jwt = require('jsonwebtoken');
const ALGORITHM = 'RS256';
const sign = (payload, expiresIn, privateKey) => {
    const signOptions = {
        algorithm: ALGORITHM,
    };
    if (expiresIn) {
        signOptions.expiresIn = expiresIn;
    }
    return jwt.sign(payload, privateKey, signOptions);
};
const verify = (token, publicKey) => {
    const verifyOptions = {
        algorithm: ALGORITHM,
    };
    try {
        return jwt.verify(token, publicKey, verifyOptions);
    }
    catch (err) {
        return err;
    }
};
const decode = (token) => jwt.decode(token);
module.exports = {
    sign,
    verify,
    decode,
};
//# sourceMappingURL=jwtService.js.map